const number = new Intl.NumberFormat("en-US", {
  maximumFractionDigits: 0,
});

const compactNumber = new Intl.NumberFormat("en-US", {
  notation: "compact",
  compactDisplay: "short",
  maximumFractionDigits: 1,
});

export function formatPercent(value: number | string): string {
  const parsed = Number(value);
  return Number.isFinite(parsed) ? `${number.format(parsed)}%` : "—";
}

export function formatCompactAmount(
  value: number | string,
  currency = "USD",
): string {
  const parsed = Number(value);
  if (!Number.isFinite(parsed)) return "—";

  try {
    return new Intl.NumberFormat("en-US", {
      style: "currency",
      currency: currency.trim().toUpperCase(),
      notation: Math.abs(parsed) >= 1000 ? "compact" : "standard",
      compactDisplay: "short",
      maximumFractionDigits: 0,
    }).format(parsed);
  } catch {
    return `${compactNumber.format(parsed)} ${currency.trim().toUpperCase()}`.trim();
  }
}

export function formatMetricValue(
  value: number | string | undefined,
  unit?: string,
): string {
  if (value == null) return "—";

  const normalizedUnit = unit?.trim().toLowerCase() ?? "";
  if (["%", "percent", "percentage", "pct"].includes(normalizedUnit)) {
    return formatPercent(value);
  }
  if (["usd", "eur", "gbp", "cad", "aud"].includes(normalizedUnit)) {
    return formatCompactAmount(value, normalizedUnit);
  }

  const parsed = Number(value);
  const rendered = Number.isFinite(parsed)
    ? (Math.abs(parsed) >= 1000 ? compactNumber : number).format(parsed)
    : String(value);

  if (!normalizedUnit || normalizedUnit === "number" || normalizedUnit === "count") {
    return rendered;
  }
  if (["day", "days"].includes(normalizedUnit)) return `${rendered} days`;
  return `${rendered} ${unit?.trim()}`;
}
